<template>
    <v-container class="sidebar-content configurable-tour-sidebar">
        <div
            ref="options"
            v-if="data.configurationOptions"
        >
            <Rooms
                v-if="data.configurationOptions"
                :rooms="data.configurationOptions"
                @select-room="selectRoom"
            />

            <v-divider class="mt-8"/>

            <RoomItems
                v-if="data.configurationOptions[activatedRoom].items && data.materials"
                v-show="data.configurationOptions[activatedRoom].items && data.configurationOptions[activatedRoom].hasCombination"
                :isLoaded="isRoomItemLoaded"
                :roomItems="data.configurationOptions[activatedRoom].items"
                :materials="data.materials"
            />
        </div>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Rooms from '@/components/sidebar/configurableTour/components/Rooms';
    import RoomItems from '@/components/sidebar/configurableTour/components/RoomItems';
    import MaterialPreview from '@/components/sidebar/configurableTour/components/MaterialPreview';
    export default {
        name: 'ConfigurableTourSidebar',
        components: {
            Rooms,
            RoomItems,
            MaterialPreview
        },
        props: [
            'data',
            'handler'
        ],
        data() {
            return {
                activatedRoom: 0,
                isLoadingScene: false
            }
        },
        computed: {
            isRoomItemLoaded() {
                return !this.isLoadingScene ? true : false;
            }
        },
        mounted() {
            this.handler();
            this.activatedRoom = this.$props.data.configurationOptions.findIndex(options => options.hasCombination === true)
            this.$props.data.configurationOptions[this.activatedRoom].active = true;

            EventBus.$emit('loadRoom', this.activatedRoom);

            EventBus.$on('sceneLoaded', () => {
                this.isLoadingScene = false;
            });
        },
        methods: {
            selectRoom(newRoom) {
                if (newRoom) {
                    if (!this.isLoadingScene) {
                        this.data.configurationOptions.forEach(configuration => configuration.active = false);
                        this.data.configurationOptions.filter(room => room.id === newRoom.id)[0].active = true;
                        this.activatedRoom = this.data.configurationOptions.findIndex(configuration => configuration.active);
                    }
                }
            }
        },
        watch: {
            activatedRoom() {
                this.isLoadingScene = true;
                EventBus.$emit('loadRoom', this.activatedRoom);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_configurable-tour_sidebar.scss";
</style>


// WEBPACK FOOTER //
// src/components/sidebar/configurableTour/ConfigurableTourSidebar.vue